/**
 * Ce que produit un template de site web.
 *
 * - `skeleton` (« Version web d'un document ») : habille un proposal classique
 *   converti en site (squelette et pages statiques recopiés, le reste parsé
 *   depuis le proposal) ;
 * - `standalone` (« Site web seul ») : sème à lui seul un site sans proposal
 *   classique.
 *
 * Choisi **à la création** et figé ensuite, comme `templatable`
 * (cf. docs/webviewer/chantier-templates-autonomes.md).
 */

export const KIND_DEFAULT = 'skeleton';
export const KIND_STANDALONE = 'standalone';

export const KIND_OPTIONS = [
  { value: KIND_DEFAULT, label: "Version web d'un document" },
  { value: KIND_STANDALONE, label: 'Site web seul' },
];

// Hors de KIND_OPTIONS : Segmented (antd) et Select (Mantine) reçoivent ces
// options telles quelles, une clé de plus finirait en attribut du DOM.
const KIND_DESCRIPTIONS = {
  [KIND_DEFAULT]:
    "Le site reprend le contenu d'un document classique, généré depuis l'éditeur avec « Générer un site web ». "
    + "Le modèle n'apporte que le cadre : menu, pied de page, pages fixes.",
  [KIND_STANDALONE]:
    'Le modèle porte tout le contenu du site, créé directement depuis la page documents, sans document classique.',
};

export function kindLabel(kind) {
  return KIND_OPTIONS.find((option) => option.value === kind)?.label;
}

export function kindDescription(kind) {
  return KIND_DESCRIPTIONS[kind];
}

export function isStandaloneTemplate(template) {
  return template?.kind === KIND_STANDALONE;
}

/** Proposal semé depuis un modèle « Site web seul », sans contenu classique. */
export const PROPOSAL_KIND_WEBSITE = 'website';

export function isStandaloneWebsite(proposal) {
  return proposal?.kind === PROPOSAL_KIND_WEBSITE;
}

/** Proposal classique dont on a généré le site : le back pose alors son
 *  `web_template_id` (cf. `saveWebData`). */
export function isDocumentWebsite(proposal) {
  return !isStandaloneWebsite(proposal) && proposal?.web_template_id != null;
}

export function hasWebsite(proposal) {
  return isStandaloneWebsite(proposal) || isDocumentWebsite(proposal);
}

/** Usage d'un site du point de vue de la liste des documents. */
export function websiteKind(proposal) {
  return isStandaloneWebsite(proposal) ? KIND_STANDALONE : KIND_DEFAULT;
}
